import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import '@lambdatestincprivate/credit-sdk/styles';
import PreApp from "./containers/PreApp";
import * as serviceWorker from "./serviceWorker";
import {
  parseJwt,
  createHash,
  isSharingRoute
} from "./utility/utilityFunctions";
import { getCookieData, setCookieData } from "./utility/cookieHandler/handler";
// import { PersistGate } from "redux-persist/integration/react";

import { store } from "./redux/store";
import {
  authorize,
  resetState,
  fetchAccessKey,
  verifyPluginAuth
} from "./redux/reducers/auth";
import { getQueryStringValue } from "./utility/utilityFunctions";
//import { getCookieValue } from "./utility/utilityFunctions";

const target = document.querySelector("#root");

/*
  Jenkins Auth
*/
let auth = getQueryStringValue("auth");
// debugger;
if (auth === "jenkins") {
  let buildId = getQueryStringValue("buildID");
  let token = getQueryStringValue("token");
  let username = getQueryStringValue("username");
  if (
    token &&
    token !== "null" &&
    token !== "" &&
    username &&
    username !== "null" &&
    username !== ""
  ) {
    setCookieData("lambdaToken", token, {
      path: "/",
      maxAge: 3600000,
      domain: ".lambdatest.com"
    });
    setCookieData("username", username, {
      path: "/",
      maxAge: 3600000,
      domain: ".lambdatest.com"
    });

    store.dispatch(verifyPluginAuth(token, username));
    if (!buildId || buildId === "null" || buildId === "") {
      alert("buildNotfound");
    }
  }
}

/*
  For Public URL Sharing
*/
let slicedPathname = window.location.pathname.split("/");
let firstPath = slicedPathname[1];
if (slicedPathname && slicedPathname[1] && slicedPathname[1] === "public") {
  console.log("Public URL Detected. Redacting Flow.");
}

/*
  Login Process Making Use Of Redux, Cookie and LocalStorage
  Process is as Follows :
  Checks For Access Token in URL.
  if found proceeds with setting of cookie and localstorage and dispatches an action for setting global state
  if not found checks cookie and still if not found redirect to login.

*/
const loginUrl =
  process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
//console.log(loginUrl);

let access_token = window.location.hash.substr(1);
let allowed = [
  "performance",
  "accessibility",
  "best-practices",
  "seo",
  "pwa",
  "book-demo"
];
// access_token = "";
if (!auth && firstPath !== "public" && !isSharingRoute()) {
  if (access_token && allowed.includes(access_token) === false) {
    let hash = createHash(access_token);
    if (hash.length > 0) {
      let token = hash[0] ? hash[0].split("=") : null;
      let expiry = hash[2] ? hash[2].split("=") : "";
      /////////================= For Validating Token ==============///////////////
      if (token) {
        let payload = parseJwt(token[1]);
        store.dispatch(authorize(token[1], payload));
        store.dispatch(fetchAccessKey(token[1]));
        // Timezone Offset
        let d = new Date();
        let n = d.getTimezoneOffset();
        let cookieName = process.env.REACT_APP_COOKIE_NAME;
        setCookieData(cookieName, token[1], {
          path: "/",
          maxAge: expiry[1],
          domain: ".lambdatest.com"
        });
        setCookieData("timezoneOffset", n, {
          path: "/",
          maxAge: `360000`,
          domain: ".lambdatest.com"
        });

        let currentUrl = window.location.hash.split("&");
        currentUrl = currentUrl[currentUrl.length - 1];
        currentUrl = currentUrl.split("=", 2);
        currentUrl = currentUrl[1];
        //Delete Logout Event After Auth For Last Saved Logout Event
        localStorage.removeItem("logout-event");

        window.location = decodeURIComponent(currentUrl);
      } else {
        // Reset State To IDLE
        store.dispatch(resetState());
      }
    } else {
      // Reset State To IDLE
      store.dispatch(resetState());
    }
  } else {
    // console.log(getCookieData("access_token"));
    //window.location.href = loginUrl;
    let cookieName = process.env.REACT_APP_COOKIE_NAME;
    if (getCookieData(cookieName)) {
      let hash = getCookieData(cookieName);
      let payload = parseJwt(hash);
      store.dispatch(authorize(hash, payload));
      store.dispatch(fetchAccessKey(hash));

      // Timezone Offset
      let d = new Date();
      let n = d.getTimezoneOffset();

      setCookieData("timezoneOffset", n, {
        path: "/",
        maxAge: `360000`,
        domain: ".lambdatest.com"
      });
      localStorage.removeItem("logout-event");
    } else {
      window.location.href = loginUrl;
    }
  }
}

const root = createRoot(target);
root.render(
  <div>
    <Provider store={store}>
      <PreApp />
    </Provider>
  </div>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
